"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSCAddressParts$ = exports.PSCAddressParts$outboundSchema = exports.PSCAddressParts$inboundSchema = void 0;
exports.pscAddressPartsToJSON = pscAddressPartsToJSON;
exports.pscAddressPartsFromJSON = pscAddressPartsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.PSCAddressParts$inboundSchema = z.object({
    address_line_1: z.nullable(z.string()),
    address_line_2: z.nullable(z.string()),
    care_of: z.nullable(z.string()),
    country: z.nullable(z.string()),
    locality: z.nullable(z.string()),
    po_box: z.nullable(z.string()),
    postal_code: z.nullable(z.string()),
    premises: z.nullable(z.string()),
    region: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "address_line_1": "addressLine1",
        "address_line_2": "addressLine2",
        "care_of": "careOf",
        "po_box": "poBox",
        "postal_code": "postalCode",
    });
});
/** @internal */
exports.PSCAddressParts$outboundSchema = z.object({
    addressLine1: z.nullable(z.string()),
    addressLine2: z.nullable(z.string()),
    careOf: z.nullable(z.string()),
    country: z.nullable(z.string()),
    locality: z.nullable(z.string()),
    poBox: z.nullable(z.string()),
    postalCode: z.nullable(z.string()),
    premises: z.nullable(z.string()),
    region: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressLine1: "address_line_1",
        addressLine2: "address_line_2",
        careOf: "care_of",
        poBox: "po_box",
        postalCode: "postal_code",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PSCAddressParts$;
(function (PSCAddressParts$) {
    /** @deprecated use `PSCAddressParts$inboundSchema` instead. */
    PSCAddressParts$.inboundSchema = exports.PSCAddressParts$inboundSchema;
    /** @deprecated use `PSCAddressParts$outboundSchema` instead. */
    PSCAddressParts$.outboundSchema = exports.PSCAddressParts$outboundSchema;
})(PSCAddressParts$ || (exports.PSCAddressParts$ = PSCAddressParts$ = {}));
function pscAddressPartsToJSON(pscAddressParts) {
    return JSON.stringify(exports.PSCAddressParts$outboundSchema.parse(pscAddressParts));
}
function pscAddressPartsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PSCAddressParts$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PSCAddressParts' from JSON`);
}
//# sourceMappingURL=pscaddressparts.js.map